import { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { CACL, IConfigComponent } from '@ts/ui-models';
import { GridColDef } from '@mui/x-data-grid-pro';
import { generateBasicColumn, IDataGridConfig } from '@ts/storybook';

interface IRoleAclsProps {
  configComponent?: IConfigComponent;
}

export const defaultConfigComponent = (): IConfigComponent => {
  return {
    componentId: 'aclPrivileges',
    aclId: 'taAclPrivileges',
    entity: 'aclPrivilege',
    fetchURL: '/api/aclPrivileges',
    crudURL: '/api/aclPrivilege',
    mainClass: CACL,
  };
};

const RoleAcls = (props: IRoleAclsProps) => {
  const { configComponent = defaultConfigComponent() } = props;

  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    return [
      generateBasicColumn({ field: 'entity' }, { field: 'cEntity.name' }),
      generateBasicColumn({ field: 'securityRole', headerName: 'Role' }, { field: 'securityRole.name' }),
      generateBasicColumn({ field: 'organization' }, { field: 'securityRole.organization.name' }),
      generateBasicColumn({ field: 'action' }, { field: 'action.name' }),
    ];
  }, [props, configComponent]);

  return <WrapperDataGrid configComponent={configComponent} dataGridConfig={config} columns={getColumns} />;
};

export default RoleAcls;
